import { render, staticRenderFns } from "./saas_edit_version.vue?vue&type=template&id=bee66282&scoped=true"
import script from "./saas_edit_version.vue?vue&type=script&lang=js"
export * from "./saas_edit_version.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bee66282",
  null
  
)

export default component.exports